import { ajax } from './ajax'

//1、获取登录验证码
export const reqLoginCode = (t) => ajax(`/sys/randomImage/${t}`)

//2、用户登录
export const reqUserLogin = (paramets) => ajax(`/sys/receptionlogin`, paramets, 'post')

//3、用户信息
export const reqUserInfo = (paramets) => ajax(`/sys/user/queryById`, paramets)

//4、用户信息修改头像
export const reqUserAvatarEdit = (paramets) => ajax(`/sys/user/appEdit`, paramets, 'put')

//5、用户信息修改手机号
export const reqUserPhoneEdit = (paramets) => ajax(`/sys/user/appEdit`, paramets, 'put')

//6、用户修改密码
export const reqUserPwdEdit = (paramets) => ajax(`/sys/user/updatePassword`, paramets, 'put')

//7、用户登出
export const reqUserLogout = () => ajax(`/sys/logout`, {}, 'post')

//8、根据TOKEN获取用户的部分信息
export const reqGetUserInfoByToken = () => ajax(`/sys/user/getUserByToken`)


//9、首页左上数据展示
export const reqTabDataList = (paramets) => ajax(`/homepage/prepareLessonsHome/getTeaMessage`, paramets)

//10、首页左上数据展示
export const reqCentreDataList = (paramets) => ajax(`/homepage/prepareLessonsHome/getTeachStatistics`, paramets)

//11、首页右上数据展示
export const reqCourseDataList = (paramets) => ajax(`/homepage/prepareLessonsHome/getSchoolTimetable`, paramets)

//12、首页底部数据展示
export const reqBaseDataList = (paramets) => ajax(`/homepage/prepareLessonsHome/getRankingList`, paramets)

//13、首页在线答疑更多
export const reqjxTalkList = (paramets) => ajax(`/jxtalk/jxTalk/list`, paramets)

//14、首页课程评价
export const reqjxEvaluationList = (paramets) => ajax(`/jxcourse/jxCourseStuEvaluation/list`, paramets)

//15、首页课程评价删除
export const reqjxEvaluationDel = (paramets) => ajax(`/jxcourse/jxCourseStuEvaluation/delete`, paramets, 'delete')

//16、查询密码强度开始状态
export const reqUserPwdinquire = (paramets) => ajax(`/sys/basicSetting/getStatusByType`, paramets)

//17、获取当前登录用户分值
export const reqUserLoginScore = (paramets) => ajax(`/classroom/basicClassroomScore/getScoreListByTea`, paramets)

//18、添加List集合
export const reqListGather = (paramets) => ajax(`/classroom/basicClassroomScore/addList`, paramets, 'post')

//19、查询三方登录openId
export const reqGetQQbind = (paramets) => ajax(`/system/sysUserThird/list`, paramets)

//20、解绑三方登录openId
export const reqDelQQbind = (paramets) => ajax(`/system/sysUserThird/deleteByUserId`, paramets, 'delete')

//21、三方登录
export const reqQQlogin = (paramets) => ajax(`/sys/StuThirdLogin`, paramets, 'post')

//22、密码正则校验
export const reqUserPassVerify = (paramets) => ajax(`/setting/sysPasswordSetting/getPwdRegex`, paramets)

//23、密码失效
export const reqUserPassSecurity = (paramets) => ajax(`/sys/basicSetting/getPwdIsInvalid`, paramets)

//24、跳转资源库调用接口
export const reqResourceLibrary = (paramets) => ajax(`/sys/saveUserInfo`, paramets)